export const SEGMENT_ACTIONS = {
    CLICKS_REGISTER_BTN : "Clicked on Register Event",
    CLICKS_FAVOURITE_BTN: "Added to Favorites",
    CLICKS_UNFAVOURITE_BTN: "Removed from Favorites",
    USER_LOGINS: "Login",
    USER_REGISTERS: "Register",
    USER_UPDATES_PROFILE: "Profile Updated",
    USER_STARTS_ONBOARDING: "Started Onboarding",
    USER_COMPLETES_ONBOARDING: "Completed Onboarding",
}